import { render, staticRenderFns } from "./ProgressInputKPI.vue?vue&type=template&id=1834b148&scoped=true"
import script from "./ProgressInputKPI.vue?vue&type=script&lang=js"
export * from "./ProgressInputKPI.vue?vue&type=script&lang=js"
import style0 from "./ProgressInputKPI.vue?vue&type=style&index=0&id=1834b148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1834b148",
  null
  
)

export default component.exports